import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export default function DeleteConfirmDialog({ 
  open, 
  onClose, 
  onConfirm, 
  loading = false, 
  unitName = '' 
}) {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon sx={{ color: 'warning.main' }} />
          <Typography variant="h6" component="div">
            KONFIRMASI HAPUS BANGUNAN
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 2 }}>
        <Typography variant="body1">
          Apakah Anda yakin akan menghapus bangunan <strong>"{unitName}"</strong>?
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          Tindakan ini tidak dapat dibatalkan.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={handleClose}
          disabled={loading}
          variant="outlined"
          sx={{ minWidth: 80 }}
        >
          BATAL
        </Button>
        <Button 
          onClick={handleConfirm}
          disabled={loading}
          variant="contained"
          color="error"
          sx={{ minWidth: 80 }}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          HAPUS
        </Button>
      </DialogActions>
    </Dialog>
  );
}
